import { Directive, inject, input } from '@angular/core';
import { MAT_DATE_FORMATS, MAT_NATIVE_DATE_FORMATS, type MatDateFormats } from '@angular/material/core';
import { DEFAULT_DATE_FORMAT } from '../../_lib/docx-core';

/**
 * Gives the Material date picker inside this element the notation of one document
 * field (its Word date picture, e.g. "dd/MM/yyyy" or "dd-MM-yyyy"). Material reads
 * the input format from MAT_DATE_FORMATS, which is otherwise one setting for all
 * pickers; each field here has its own, so the panel shows the date exactly as the
 * document does.
 */
@Directive({
  selector: '[appDateFormat]',
  providers: [
    {
      provide: MAT_DATE_FORMATS,
      useFactory: (): MatDateFormats => ({
        parse: { ...MAT_NATIVE_DATE_FORMATS.parse },
        display: { ...MAT_NATIVE_DATE_FORMATS.display },
      }),
    },
  ],
})
export class DateFormat {
  public readonly appDateFormat = input<string | undefined>();

  constructor() {
    const formats = inject(MAT_DATE_FORMATS);
    const picture = () => this.appDateFormat() || DEFAULT_DATE_FORMAT;

    // Read on every use, so the format always follows the field it belongs to.
    Object.defineProperty(formats.parse, 'dateInput', { get: picture });
    Object.defineProperty(formats.display, 'dateInput', { get: picture });
  }
}
